import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { newI18n } from '../core/Const';
export interface HomeHotelParnerProps extends BaseComponentProps { }
export interface HomeHotelParnerState extends BaseComponentState { }
export class HomeHotelParner extends BaseComponent<HomeHotelParnerProps, HomeHotelParnerState> {

	translation = {
		Title: newI18n("HOME.PARTNER.Title", "Our Partner"),
		SubTitle: newI18n("HOME.PARTNER.SubTitle", " We partner with the leading international as well as local hotel brands to ensure the best possible stay for you in Bali. We also work with some of Bali’s leading charities to support both the island and its people"),
		Review: newI18n("HOME.PARTNER.Review", "Hotel review powered by"),
		Booking: newI18n("HOME.PARTNER.Booking", "Hotel Booking powered by"),
	};

	render() {
		if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
		let imgs = [];
		let logos = [
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/aston-hotels.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/hardrock-hotels-bali.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/hilton.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/hyatt.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/ibissytles.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/marriot.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/Mercure_Hotels.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/novotel.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/pullman.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/radison-hotels.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/swiss-belhotel.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/seraton.png'
		];
		let keyImg: number = 0;
		for (let a of logos) {
			keyImg++;
			imgs.push(
				<img key={`img${keyImg}`} src={a} className="col-md-3 col-sm-3 col-xs-3" />
			);
		}
		// let supports = [];
		let logoss = [
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/airasia.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/jetstar.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/bvam1.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/bali-tours-and-more.png'
		];
		for (let a of logoss) {
			keyImg++;
			imgs.push(
				<img key={`img${keyImg}`} src={a} className="col-md-3 col-sm-3 col-xs-3" />
			);
		}

		// let charitys = [];
		let charLogos = [
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/Sole-Men-Logo-tagline-NEW.png',
			'https://storage.googleapis.com/bali-hotel-images/hotels-partner/Stellas_child_logo.png'
		];
		// let keyImg: number = 0;
		for (let a of charLogos) {
			keyImg++;
			imgs.push(
				<img key={`img${keyImg}`} src={a} className="col-md-3 col-sm-3 col-xs-3" />
			);
		}
		return (
			<section className="container-fluid container-fullw bg-white" data-stellar-background-ratio="0.5" >
				<div className="container">
					<div className="col-md-4" style={{ fontSize: 16 }}>
						<h3>{this.translation.Title}</h3>
						<p>
						{this.translation.SubTitle}
						</p>
						<p style={{ paddingTop: 30 }}>
							{this.translation.Review}<br />
							<img src="https://storage.googleapis.com/bali-hotel-images/TA_logo_primary200.png" />
						</p>

						<p style={{ paddingTop: 30 }}>
							{this.translation.Booking}<br />
							<img src="https://storage.googleapis.com/bali-hotel-images/hotelbed.png" />
						</p>
					</div>
					<div className="col-md-8"> 
						{imgs} 
					</div> 
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/home/HomeHotelParner.tsx